import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import ActiveLoans from "../../views/MortgageView/active-loans";

const MortgageActiveLoans = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader
        pageTitle="Mortgage-Application"
        routeName="bvn-otp-verification"
      />
      <ActiveLoans />
    </Layout> 
  );
}; 

export default MortgageActiveLoans;
